"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _PageLoader = _interopRequireDefault(require("./PageLoader"));

var _modal = _interopRequireDefault(require("./modal"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _indexModule = _interopRequireDefault(require("../static/styles/index.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// Setup CSS Module
var cx = _bind.default.bind(_indexModule.default);

class GetWaiting extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      visible: this.props.visible,
      className: cx("fade", "wallet-modal", "enter-passphrase"),
      dialogClassName: cx("modal-dialog-centered")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: cx("modal-body")
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: cx("title", "d-block", "text-center", "mt-4")
    }, "Waiting for transaction"), /*#__PURE__*/_react.default.createElement("p", {
      className: cx("subtitle", "d-block", "text-center", "mb-4")
    }, "Please follow the instructions on your devide!"), /*#__PURE__*/_react.default.createElement(_PageLoader.default, {
      type: "bar"
    })));
  }

}

var _default = GetWaiting;
exports.default = _default;